import { render, staticRenderFns } from "./client-plan-form.vue?vue&type=template&id=99e20ef2"
import script from "./client-plan-form.vue?vue&type=script&lang=js"
export * from "./client-plan-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports